import axios from 'axios';

// Smart API URL: use same-origin /api when deployed, env var for dev/preview
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const isDeployed = typeof window !== 'undefined' &&
  !window.location.hostname.includes('preview.emergentagent.com') &&
  !window.location.hostname.includes('localhost');

// When deployed to lamfon.app, use same-origin to avoid cross-origin cookie issues
const API_BASE = isDeployed ? '/api' : `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Add auth token as fallback for Authorization header
// Primary auth: httpOnly cookie (set by backend, sent automatically via withCredentials)
// Fallback: Bearer token from localStorage (for mobile PWA where cookies may not persist)
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('lamfon_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    // localStorage not available (private browsing)
  }
  return config;
});

export default api;
export { API_BASE, BACKEND_URL };
